import { IProductListPatchModel } from '@epicuro-next/data/lists';
import { createAction, props } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

export type PatchProducts = {
  listId: string;
  patchModel: IProductListPatchModel;
};

/**
 * Action for patching the active ProductList
 */
export const patchActiveProductList = createAction(
  '[ProductList] Patch active product list',
  props<{ product: Product }>(),
);

/**
 * Action for handling patching
 */
export const patchProductsBulk = createAction(
  '[ProductList] Patch products in product list bulk',
  props<PatchProducts>(),
);

export const patchProductsBulkSuccess = createAction(
  '[ProductList] Patch products in product list bulk success',
  props<{ products: PatchProducts[] }>(),
);

/**
 * Action for handling if something went wrong
 */
export const patchProductsBulkFailed = createAction(
  '[ProductList] Patch products in product list bulk failed',
  props<{ products: PatchProducts[] }>(),
);
